//File imports
import HttpService from '../../../services/Http/HttpService';
import Logger from '../../../services/Logger/Logger';
import Validator from '../../../services/Validator/Validator';
import {
    API_CREATE_DOCUMENT_CATEGORY_PAGE,
    API_DELETE_DOCUMENT_CATEGORY_PAGE,
    API_GET_ALL_DOCUMENT_CATEGORY_PAGE,
    API_UPDATE_DOCUMENT_CATEGORY_PAGE,
} from './DocumentCategoryConstants';
import DocumentCategoriesResultsPojo from './DocumentCategoryResultPojo';

export class DocumentCategoryService {
    private httpService = new HttpService();
    private logger = new Logger();
    private validator = new Validator();

    async getAll(): Promise<DocumentCategoriesResultsPojo> {
        try {
            const httpResult = await this.httpService.get(
                API_GET_ALL_DOCUMENT_CATEGORY_PAGE,
                {},
            );
            return {
                isSuccess: httpResult.data.isSuccess,
                documentCategories: httpResult.data.response,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async delete(
        documentCategoryPageId: number,
        status: number,
    ): Promise<Boolean> {
        try {
            this.validator.validatePositiveInteger(documentCategoryPageId);
            this.validator.validateIntegerIncludingZero(status);

            const httpResult = await this.httpService.delete(
                API_DELETE_DOCUMENT_CATEGORY_PAGE,
                { documentCategoryPageId, status },
            );
            return httpResult.data.isSuccess;
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async create(name: string): Promise<{ success: boolean; message: string }> {
        try {
            this.validator.isValidString('Name', name);
            const payload = {
                name,
            };

            const httpResult = await this.httpService.post(
                API_CREATE_DOCUMENT_CATEGORY_PAGE,
                payload,
            );
            return {
                success: httpResult.data.isSuccess,
                message: httpResult.data.messageForUser,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async update(
        documentCategoryPageId: number,
        name: string,
    ): Promise<{ success: boolean; message: string }> {
        try {
            this.validator.validatePositiveInteger(documentCategoryPageId);
            this.validator.isValidString('Name', name);
            const payload = {
                documentCategoryPageId,
                name,
            };
            const httpResult = await this.httpService.put(
                API_UPDATE_DOCUMENT_CATEGORY_PAGE,
                payload,
            );
            return {
                success: httpResult.data.isSuccess,
                message: httpResult.data.messageForUser,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }
}
